import React, { useState, useEffect, FC, ChangeEvent } from 'react';

interface DateTimeAlarmProps {
  alarm: any;
  onChange: (newAlarm: any) => void;
}

const DateTimeAlarm: FC<DateTimeAlarmProps> = ({ alarm, onChange }) => {
  const [datetime, setDatetime] = useState<string>("");

  useEffect(() => {
    if (alarm && alarm.datetime) {
      setDatetime(alarm.datetime); // Initialiser l'état si l'alarme contient une valeur datetime
    } else {
      setDatetime("");  // Réinitialisation si l'alarme est vide ou ne contient pas de datetime
    }
  }, [alarm]);

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    setDatetime(newValue); // Mise à jour de l'état local
    onChange({ type: "DateTimeAlarm", datetime: newValue }); // Mise à jour dans le parent
  };

  return (
    <div className="input-group col-md-4 col-sm-4">
      <span
  className="input-group-addon"
  style={{ backgroundColor: '#ff7e41', color: 'white', width: '40px', textAlign: 'center' }} 
           >
            <i className="fa fa-calendar" />
       </span>
      <input
        type="datetime-local"  // Utilisation de datetime-local pour gérer la date et l'heure
        className="form-control input-sm"
        name="no_transmission_date"
        value={datetime} // Valeur de l'input contrôlée par l'état local
        onChange={handleChange} // Utilisation de handleChange pour gérer les changements
      />
    </div>
  );
};

export default DateTimeAlarm;


